const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCouch2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 946.53 456.4",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "551b3286-a1b7-44a9-9460-35259966e230"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.43,269.45c-20.2,8.7-55,61.2-49.9,98.9,5.8,43.2,28.8,72,43.2,80.7s135.4,11.5,159.4-1.9,42.3-76.5,39.4-99.9c-3.8-30.7-34.6-71.1-58.6-77.5-18.6-5-133.5-.3-133.5-.3",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path742",
    d: "M884.58,320.71,913,435.12,884.58,320.71",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path746",
    d: "M895.66,319.08l21.81,131c.43,2.73-1.14,5.46-3.56,5.94s-4.42-1.12-5.13-3.53L873.57,325.35c-1.85-6.75,1.43-14,7.56-16.07s12.4,1.61,14.25,8.51a3.46,3.46,0,0,1,.28,1.29",
    style: {
      fill: "#a75f37"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path750",
    d: "M65.58,320.73,37.17,435.19",
    style: {
      fill: "#d9a476"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path754",
    d: "M76.13,325.11,41.55,452.49c-.73,2.69-3.22,4.21-5.61,3.39A5.27,5.27,0,0,1,32.83,450L55.15,319.26c1.15-6.56,6.75-10.89,12.67-9.6s9.66,7.61,8.52,14.28a4.8,4.8,0,0,1-.21,1.17",
    style: {
      fill: "#a75f37"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path758",
    d: "M523,256.71c0,33.08-20.77,59.81-46.26,59.81s-46.38-26.86-46.38-59.81,20.77-59.81,46.38-59.81S523,223.63,523,256.71",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path762",
    d: "M479.63,303.43H469c2.45-2.57,4-6.85,5.14-12.11,1.1,5.38,2.82,9.79,5.51,12.11M474,252.66c-.73-5-1.59-9.42-2.45-12.85,1.23-8.81,2.2-24,3.06-42.45.74,16.76,1.59,30.71,2.69,39.76a80.84,80.84,0,0,0-3.3,15.54",
    style: {
      fill: "#d02d27"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path766",
    d: "M906.34,34.3c21.49,20.48,27.36,176.62,13.75,193.38S486.35,255.9,479.62,248.16,467.16,2.21,487.64.21,886.29,15.39,906.34,34.3",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path770",
    d: "M906.32,34.3h0",
    style: {
      fill: "#f9dcda"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path774",
    d: "M477.24,237.12c-1-9.15-2-23-2.71-39.73.42-9.44.71-19.73,1-30.59,12.14,14.44,32.58,18,59.88,18,14,0,29.87-1,47.45-1.86s36.73-1.86,57.45-1.86a541.31,541.31,0,0,1,59.17,3,373.44,373.44,0,0,0,38.59,2.15c69.74,0,109.19-22.15,127.63-35,29.72-21,38-75.6,39.73-117.33.28.28.71.42.86.71h0c11.29,10.72,18.29,59.17,20.43,105.19A13.22,13.22,0,0,0,920,151.22v75.61C891.28,214,817.82,188.67,705.34,188.67H695.19c-147.92,2-210.37,34.87-216.23,44.88a6.83,6.83,0,0,0-1.72,3.57",
    style: {
      fill: "#db423c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path778",
    d: "M872.54,45.28a41.56,41.56,0,0,0-5.76-1.13c-2-.28-3.79-.56-5.75-.7-3.8-.42-7.73-.84-11.52-1.12-7.72-.56-15.45-1.27-23.17-1.69s-15.45-1-23.17-1.4L780,38l-46.35-2.38L687.31,33.2,641,30.81l-46.34-2.24c-15.45-.71-30.9-1.41-46.34-2-7.73-.28-15.45-.56-23.18-.7h-14.6l-2.95.14a40.11,40.11,0,0,0-5.76.56c7.59-2,15.31-2.53,23-3.09s15.45-.84,23.31-1.12c12.36-.42,24.72-.57,37.08-.57h9.41c15.59,0,31,.43,46.48.85s31,1.12,46.48,1.82c15.45.85,30.9,1.83,46.35,2.81,15.44,1.27,30.89,2.39,46.34,3.93s30.89,3.23,46.2,5.34c7.72,1.12,15.31,2.25,23,3.51,8,1.12,15.73,2.53,23,5.2",
    style: {
      fill: "#e56862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path782",
    d: "M922.26,305.18c16.94-8,17.94-66.89,10.91-71.77S842.88,186.47,695,188.48s-210.29,34.88-216.32,44.93-11.91,67.9,4,71.77,439.52,0,439.52,0",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path786",
    d: "M479.63,303.43h0c-2.69-2.32-4.41-6.6-5.51-12.11h0c1.1,5.38,2.82,9.79,5.51,12.11",
    style: {
      fill: "#cc211c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path790",
    d: "M916.57,303.35H802.76a114.05,114.05,0,0,0-21-23.1c63-11,112.38-26.24,118.94-40.79q4.07-9.19,7.27-18h0c4.71,1.86,8.7,3.57,12.12,5v73.58a3.57,3.57,0,0,1-3.56,3.28m-318.89,0H479.6c-2.71-2.28-4.42-6.7-5.56-12.12A91.57,91.57,0,0,0,475.47,274,173.38,173.38,0,0,0,474,252.44c1-7.7,2.42-14.12,4-17.68,4.14,21.53,10.84,46.63,21.54,50.06,24.67,8,61.46,11.4,102.82,11.4-1.71,2.43-3.14,4.71-4.71,7.13",
    style: {
      fill: "#ef4035"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path794",
    d: "M531.35,243.58a135.8,135.8,0,0,1,19.66-4c6.69-1,13.25-1.82,19.94-2.51,13.25-1.4,26.63-2.51,40-3.21,26.64-1.67,53.41-2.51,80.18-2.79,5.72,0,11.3-.14,17-.14q31.59,0,63.17,1.26c6.7.27,13.39.55,20.08,1s13.39.84,20.08,1.4c3.35.28,6.7.55,10,1s6.7.7,10,1.12a185.75,185.75,0,0,1,19.81,3.21l-5-.28-5-.14c-3.35-.14-6.7-.14-10.05-.28-5.29,0-10.45-.14-15.75-.14H791.41l-19.94.14-79.9.7-79.9.83c-13.39.14-26.64.28-40,.7l-10,.28-10,.42-5,.28-5,.27-5,.42c-1.82.14-3.49.42-5.16.56",
    style: {
      fill: "#f57065"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path798",
    d: "M35.44,34.2C13.52,54.65,10.58,210.31,24.54,227s438,28.78,444.93,21.06S482.08,2.11,461.39.15,55.77,15.34,35.44,34.2",
    style: {
      fill: "#e04d46"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path802",
    d: "M474.52,68.36c-.86-18.07-2.32-34.19-4.28-46.16h0c2.08,12,3.42,28.09,4.28,46.16h0",
    style: {
      fill: "#f9dcda"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path806",
    d: "M470.28,22.17h0c-.61-3.78-1.34-7.19-2.07-10.12h0c.73,2.93,1.46,6.34,2.07,10.12",
    style: {
      fill: "#d48d65"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path810",
    d: "M468.23,12h0C466.4,4.69,464.08.43,461.4.18h0c2.68.25,5,4.51,6.83,11.82",
    style: {
      fill: "#bab4b2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path814",
    d: "M471.47,239.69h0c1.22-8.92,2.32-23.94,3-42.38h0c-.73,18.44-1.83,33.59-3,42.38",
    style: {
      fill: "#cb2721"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path818",
    d: "M474.57,197.28h0m1-30.55h0c.74-31.89.49-67.94-1-98.37h0c1.47,30.43,1.59,66.48,1,98.37",
    style: {
      fill: "#db423c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path822",
    d: "M474.52,197.33h0c.37-9.4.73-19.79,1-30.54h0c-.25,10.75-.61,21-1,30.54",
    style: {
      fill: "#d63933"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path826",
    d: "M471.52,239.68a31.77,31.77,0,0,0-2.2-6h0c-6.11-10-68.79-42.89-216.65-44.84-3.42,0-6.84-.13-10.26-.13-113.76,0-187.69,25.91-215.92,38.62V187.63c21-3.18,46.07-4.16,73.44-4.16,25.78,0,53.52,1,81.63,1.83s56.45,1.84,83.58,1.84c71.36,0,133.8-6.36,157.5-36.17C455.88,109.3,460.28,37.45,460.4.06a3.8,3.8,0,0,1,1.22.12h.12c2.69.25,5,4.52,6.85,11.85h0c.73,2.94,1.46,6.36,2.07,10.15,2,12,3.3,28.1,4.28,46.18,1.47,30.43,1.59,66.48,1,98.37-.25,10.75-.61,21.14-1,30.55h0c-1.22,18.45-2.2,33.6-3.42,42.4",
    style: {
      fill: "#db423c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path830",
    d: "M34.52,116a83.26,83.26,0,0,1,.71-12.1A101.37,101.37,0,0,1,37.7,92,119.48,119.48,0,0,1,41.34,80.4,105.62,105.62,0,0,1,46,69a71.35,71.35,0,0,1,6.47-10.7c.71-.82,1.29-1.65,2-2.47A23.89,23.89,0,0,1,57,53.48a22.62,22.62,0,0,1,5.88-3.29c7.87-3.29,15.75-5.06,23.74-6.82,31.75-6.82,63.84-10.46,95.94-14,16.1-1.53,32.09-3.06,48.2-4.35s32.1-2.47,48.2-3.29c32.21-1.88,64.43-3.18,96.64-3.29-32.09,3.76-64.07,7.05-96.17,10.11l-48.08,4.7c-16,1.53-32.1,3.06-48.09,4.82q-24,2.3-48,5.29c-16,1.88-31.86,4-47.62,6.7C79.9,51.48,71.91,53,64.74,55.6A25,25,0,0,0,60,57.83c-.7.47-1.29,1.18-2,1.76l-1.89,2a70.53,70.53,0,0,0-6.58,9.64A129.71,129.71,0,0,0,39.81,93c-2.47,7.29-4.7,15-5.29,23",
    style: {
      fill: "#e56862"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path834",
    d: "M24.89,305.64C8,297.69,7,238.8,14,233.78s90.47-46.89,238.61-44.93,210.69,34.89,216.68,44.93,11.88,67.82-3.91,71.86c-16,3.92-440.48,0-440.48,0",
    style: {
      fill: "#f3574a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path838",
    d: "M469.24,233.76h0",
    style: {
      fill: "#d7312b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path842",
    d: "M469,303.37H29.85a3.39,3.39,0,0,1-3.42-3.3V227.38l.74-.36c.73,18,3.54,51.55,13.68,53.87a37,37,0,0,0,7,.37c53.63,0,385.3-21.5,413.27-54.36,4.4,2.8,7.21,5.13,8.19,6.84h0c3.05,5.25,6.23,23.45,6.23,40.31A83.76,83.76,0,0,1,474,291.27h0c-1,5.38-2.57,9.65-5,12.1",
    style: {
      fill: "#ef4035"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path846",
    d: "M65.63,247.6A139.34,139.34,0,0,1,85.22,243c6.61-1.18,13.22-2.13,19.83-3.07,13.34-1.77,26.68-3.19,40-4.37,26.67-2.48,53.47-4,80.14-5.08,21-.82,42-1.29,63-1.29,5.78,0,11.57,0,17.23.11,6.73.12,13.34.12,20.07.36s13.34.47,20.07.82c3.3.24,6.72.36,10,.59s6.73.48,10,.83a187.64,187.64,0,0,1,19.95,2.6l-5.08-.12h-7.31c-2.6,0-5.08,0-7.68.12-6.72.12-13.33.23-20.06.47s-13.34.35-20.07.59l-20.06.71-80,3.07-80,3.18c-13.33.59-26.67,1.18-40,1.89l-10,.59-10,.71-5,.36-5,.47c-1.65.12-3.31.35-5,.59a22.45,22.45,0,0,0-4.72.47",
    style: {
      fill: "#f57065"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path850",
    d: "M916.62,329.72H29.77A29.71,29.71,0,0,1,0,300.1V153a13.23,13.23,0,1,1,26.46,0V300.1a3.25,3.25,0,0,0,3.31,3.3H916.62a3.24,3.24,0,0,0,3.3-3.3V151a13.24,13.24,0,1,1,26.47,0V300.1a29.71,29.71,0,0,1-29.77,29.62",
    style: {
      fill: "#cc9266"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path854",
    d: "M126.2,315.53c-60.66,0-100.33-.57-104.47-2-19-6.71-6.28-136-10.85-173.54a12.07,12.07,0,0,1,2.43-.29,13.09,13.09,0,0,1,13.13,13.13V300h0a3.35,3.35,0,0,0,3.42,3.28H597.74c-1.57,2.57-3,5.14-4.43,7.71-164.83,2.57-352.94,4.57-467.11,4.57m679.48-7.71c-1-1.43-2-3-3-4.42H916.57a3.36,3.36,0,0,0,3.43-3.29,15.87,15.87,0,0,0,2.28,5c-.14.43-45.81,1.43-116.6,2.71",
    style: {
      fill: "#c07f54"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path858",
    d: "M916.62,329.72H817.09c-.87-2.44-2-4.89-3.17-7.33,65.73-2.59,108.59-6,111.47-10.5,10.79-17,5.75-133,5.61-173.89a12.92,12.92,0,0,1,2.3-.29A13.2,13.2,0,0,1,946.53,151V300.1a29.92,29.92,0,0,1-29.91,29.62",
    style: {
      fill: "#c07f54"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path862",
    d: "M585.06,329.84H398.78c62-.51,126-1.15,187-2-.25.64-.51,1.27-.76,2",
    style: {
      fill: "#c07f54"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path866",
    d: "M629.52,269.38c-20.18,8.71-55,61.23-49.9,99,5.8,43.26,28.75,72,43.26,80.72s135.45,11.47,159.37-1.94,42.29-76.57,39.39-99.93c-3.87-30.68-34.56-71-58.61-77.54-18.66-4.84-133.51-.28-133.51-.28",
    style: {
      fill: "#5e8c89"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g868"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#551b3286-a1b7-44a9-9460-35259966e230)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path878",
    d: "M609.62,437.6h0a34.9,34.9,0,0,1-2.83-3.34h0c.9,1.16,1.93,2.31,2.83,3.34",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path882",
    d: "M693.66,417.83h-1.89a24,24,0,0,1-.67-2.82h2.56q14.51,0,29-.81c-.14.95-.14,1.89-.27,2.83-9.54.53-19.07.8-28.74.8m-4.84,0c-10.34-.13-20.69-.4-30.89-1.07-.27-.94-.68-1.88-.94-3,10.34.67,20.82,1.08,31.16,1.21a20.58,20.58,0,0,1,.67,2.82m36.53-.94c.14-.94.14-1.88.27-2.82,4.7-.27,9.41-.67,14.11-1.07-1.08.53-2.29,1.2-3.5,1.74s-2.55,1.21-3.76,1.75l-7.12.4m-70.38-.4c-10.34-.67-20.82-1.75-31.16-3.09-.4-.94-.67-2-1.07-3,10.34,1.35,20.81,2.42,31.16,3.23.4.8.67,1.74,1.07,2.82",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path886",
    d: "M618.08,412.59c-9.14-1.29-18.15-2.7-27.29-4.51-.52-1-.9-2.05-1.42-3.08,8,1.54,16,3,23.94,4.11a14.45,14.45,0,0,0,2.19,1.68,19.4,19.4,0,0,0,2.58,1.8",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path890",
    d: "M724,395.8c-12.46,0-24.91-.27-37.37-.95-.14-1-.41-1.89-.54-2.84,12.72.67,25.45.95,38.05.95a19.23,19.23,0,0,0-.14,2.84m2.85,0c0-.95.13-1.9.13-2.84,8.8,0,17.61-.28,26.41-.55-.14.95-.14,1.9-.27,2.85-8.81.27-17.61.4-26.27.54m29.11-.68c.14-.95.14-1.89.27-2.84l7.45-.41c-.68.95-1.35,2-2.17,3-1.89,0-3.79.14-5.55.27m-72.31-.54c-11-.54-21.8-1.49-32.64-2.57-.27-.95-.4-1.9-.67-2.85,10.83,1.09,21.8,1.9,32.77,2.58.13.94.4,1.89.54,2.84",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path894",
    d: "M648.08,391.84c-10.28-1-20.69-2.34-31-3.9-.13-.91-.39-1.95-.52-2.86q15.42,2.34,30.84,3.9a29.24,29.24,0,0,0,.65,2.86",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path898",
    d: "M598.71,385c-5.63-1-11.12-2.05-16.75-3.07a27.93,27.93,0,0,1-.64-3.07c5.5,1.15,11.12,2.17,16.62,3.07.26,1,.51,2,.77,3.07",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path902",
    d: "M694.86,375.05c-3.81,0-7.75,0-11.56-.14-.13-1-.27-1.9-.4-2.85,3.94.13,8,.13,12,.13,9.93,0,20-.27,29.91-.95v2.86c-10.06.68-20,.95-29.91.95m-14.55-.27c-10.87-.27-21.75-1.09-32.63-2.18-.13-1-.13-1.9-.27-2.85,10.88,1.09,21.75,1.77,32.63,2.17a17.72,17.72,0,0,0,.27,2.86m47.18-.82v-2.85c9-.68,17.81-1.5,26.79-2.59v2.86c-9,1.09-17.81,1.9-26.79,2.58m-82.66-1.49c-9.93-1.09-20-2.45-29.78-4.08v-2.86c9.79,1.63,19.72,3.13,29.64,4.08a9.82,9.82,0,0,0,.14,2.86M757,371v-2.85q9.16-1.23,18.35-2.86c-.27.95-.54,2-.82,3C768.82,369.34,763,370.16,757,371m-160.58-6.25c-5.84-1.23-11.55-2.59-17.4-4.08a19.57,19.57,0,0,1,.14-2.86c5.84,1.5,11.55,2.86,17.4,4.08a19.57,19.57,0,0,0-.14,2.86",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path906",
    d: "M682.54,347.45h-1.66V344.7h1.66c13.92,0,27.84-.55,41.63-1.8,0,1,.13,1.93.13,2.76-13.92,1.24-27.84,1.79-41.76,1.79m-4.41,0c-10.34-.13-20.68-.55-31-1.37,0-1,.14-1.93.14-2.76,10.2.83,20.54,1.24,30.74,1.24a20,20,0,0,0,.14,2.89m-33.91-1.51c-5.65-.42-11.17-1-16.68-1.66,1-.82,1.79-1.65,2.62-2.48,4.82.55,9.51,1,14.19,1.38,0,.83-.13,1.79-.13,2.76m82.84-.55c0-1-.14-1.93-.14-2.76,8.55-.83,17-1.79,25.5-3.17.14,1,.14,1.93.28,2.76-8.41,1.24-17,2.34-25.64,3.17m28.54-3.59c-.14-1-.14-1.93-.28-2.75,8-1.25,16-2.76,24-4.42v2.9c-7.85,1.65-15.85,3-23.7,4.27M600,340.15c-5.79-1-11.44-2.21-17.23-3.45.27-1,.55-1.79.83-2.76,5.65,1.25,11.44,2.35,17.09,3.45a15.91,15.91,0,0,1-.69,2.76m216.41-12c-.41-.83-.68-1.8-1.1-2.62h0a23.22,23.22,0,0,0,1.1,2.62h0",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path910",
    d: "M691.45,322.63c-3.3,0-6.46,0-9.75-.14.14-1,.14-1.92.27-2.88,3.16.13,6.32.13,9.48.13,10.44,0,20.74-.41,31.17-1.09.14,1,.14,1.92.28,2.74-10.44,1-21,1.24-31.45,1.24m-12.5-.14c-9.34-.27-18.81-.82-28.15-1.78.27-1,.41-1.79.69-2.75,9.2.82,18.4,1.51,27.74,1.78-.14.83-.14,1.79-.28,2.75m46.69-1.23c-.13-1-.13-1.93-.27-2.75,7.83-.69,15.52-1.51,23.21-2.61.14,1,.41,1.78.55,2.75-7.69,1.09-15.52,2.06-23.49,2.61M752,318.37c-.14-1-.41-1.78-.55-2.75,8.65-1.23,17.44-2.74,26-4.66.14,1,.27,1.92.41,2.74-8.51,1.79-17.17,3.3-25.82,4.67m-142.14-3.71c-5.49-1.1-11-2.33-16.34-3.57.41-.82,1-1.78,1.37-2.61,5.5,1.38,10.85,2.48,16.35,3.57a26.37,26.37,0,0,0-1.38,2.61M805.16,307l-1.65-2.47h0l1.65,2.47h0",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path914",
    d: "M700.29,303c-5.2,0-10.4-.13-15.46-.27a15.68,15.68,0,0,1,.69-2.74c4.92.14,9.84.28,14.9.28,6.84,0,13.54-.14,20.38-.55a20,20,0,0,1,.27,2.87c-7,.28-13.81.41-20.78.41M682,302.54c-7.39-.41-14.63-1-21.88-1.77A21.22,21.22,0,0,0,661,298c7.12.82,14.36,1.37,21.61,1.78a16.76,16.76,0,0,0-.68,2.73m41.85-.41c-.14-.95-.28-1.91-.41-2.87,7-.41,13.81-1.09,20.65-1.91.27.95.55,1.77.82,2.73-7,1-14,1.64-21.06,2.05m23.93-2.32c-.27-1-.55-1.78-.82-2.74,8.07-1.09,16-2.32,24.07-4,.41.82.82,1.77,1.23,2.59-8.07,1.65-16.27,3-24.48,4.11m-124.45-5.2q-8.41-1.85-16.82-4.1c.68-.82,1.23-1.64,1.91-2.46,5.61,1.5,11.35,2.87,17.1,4.1-.82.82-1.51,1.64-2.19,2.46m169.45-3.69c-.69-.82-1.51-1.64-2.19-2.33h0a18.58,18.58,0,0,1,2.19,2.33h0",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path918",
    d: "M690.34,284.33h-.41c.27-.95.68-1.9,1-2.85,9.11,0,18.22-.27,27.2-1,.13,1,.27,1.9.4,2.85-9.38.68-18.76.95-28.14.95m-3.53,0c-7.35,0-14.69-.27-21.89-.81.54-.95,1-1.77,1.49-2.72,7.21.41,14.28.68,21.48.68-.41.95-.68,1.9-1.08,2.85m-25-.95c-.95,0-1.77-.13-2.72-.13-2.18-1.77-5.44-2.72-10.06-2.72a24.11,24.11,0,0,0-3,.13,18.9,18.9,0,0,0-4.62.95c-.41,0-.82-.13-1.09-.13.54-.82,1.22-1.77,1.77-2.59,7.07.82,14.13,1.5,21.21,1.91a20.53,20.53,0,0,0-1.5,2.58m59.55-.27c-.14-.95-.27-1.9-.41-2.86q8.57-.6,17.13-1.63c.27.95.68,1.77,1,2.72-5.84.82-11.83,1.36-17.67,1.77m20.53-2c-.27-.95-.68-1.77-1-2.72,6.66-.82,13.32-1.77,20-3,.55.82,1.09,1.77,1.63,2.58-6.93,1.36-13.73,2.31-20.66,3.13m-104.69-.14c-6.53-.81-13-1.9-19.58-3,.95-.81,1.77-1.63,2.72-2.44,6.26,1.08,12.37,2,18.63,2.71a31.38,31.38,0,0,0-1.77,2.72m128.21-3.4c-.54-.81-1.09-1.76-1.63-2.58.81-.13,1.49-.27,2.31-.41.41.82.95,1.64,1.36,2.59-.55.13-1.23.27-2,.4m9.92-1.9c-1.22-.81-2.31-1.49-3.53-2.17h0a31.13,31.13,0,0,1,3.53,2.17h0",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path922",
    d: "M634.3,436.17c-1,0-2.21-.13-3.38-.13a152.31,152.31,0,0,1-10-22.53c4.17-1.56-12.76-31-5.86-52.72v4.69a21.06,21.06,0,0,0,.13,2.86c.26,5.6.79,11.2,1.57,16.66a21.89,21.89,0,0,0,.52,2.87A150.44,150.44,0,0,0,623,410.39c.4,1,.66,1.95,1,3a127.28,127.28,0,0,0,10.28,22.79m.52-151.67c.78-1.17,1.56-2.34,2.34-3.64.53-.91,1.18-1.69,1.7-2.6a118.82,118.82,0,0,1,7.16-9.51c1.17,0,2.47-.13,3.77-.13-2.73,3.26-5.2,6.51-7.68,10-.65.91-1.17,1.69-1.82,2.6a1.3,1.3,0,0,1-.52.65c-1.56.78-3.26,1.56-4.95,2.6",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path926",
    d: "M661.85,435.38c-2.49-6.3-4.86-12.61-7-19-.26-.92-.66-2-.92-2.89a216.27,216.27,0,0,1-5.91-21.8c-.26-.92-.39-2-.65-2.89-1-5.38-2-10.9-2.63-16.41a21.7,21.7,0,0,1-.26-2.89c-.13-1.45-.27-2.89-.4-4.33-.26-3.16-.26-6.31-.26-9.46s.13-6.56.39-9.85a19.55,19.55,0,0,1,.27-2.75,166.46,166.46,0,0,1,3.28-21.41c1.58-2.1,3.15-4.33,4.6-6.56-.27.91-.53,1.83-.79,2.75s-.4,1.84-.66,2.76a147.51,147.51,0,0,0-3.68,22.59c-.13.92-.13,1.83-.26,2.75-.13,3.16-.26,6.44-.26,9.59s.13,6.17.26,9.19c.13,1.58.26,3.28.4,4.86.13.92.13,2,.26,2.89.65,5.51,1.57,11,2.62,16.41.27.92.4,2,.66,2.89,1.71,7.36,3.68,14.58,6,21.67.26.92.66,2,.92,2.89,2.1,6.17,4.33,12.34,6.83,18.51a7.83,7.83,0,0,1-2.89.53M662.11,289a9.3,9.3,0,0,0-1.31-3.8,12.63,12.63,0,0,0,.92-1.84c.52-.92.92-1.84,1.44-2.76,2.37-4.33,4.86-8.4,7.62-12.48a32.49,32.49,0,0,0,3.55-.13c-2.89,4.07-5.52,8.41-8,12.74a28,28,0,0,0-1.44,2.76L662.11,289",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path930",
    d: "M692.11,430.25c-1.19-4.1-2.25-8.2-3.31-12.44a21.54,21.54,0,0,1-.66-2.78c-1.72-6.75-3.17-13.5-4.5-20.38-.13-.93-.39-1.85-.53-2.91-1.06-5.56-2-11.25-2.78-16.94l-.39-2.78c-.66-5.16-1.19-10.32-1.46-15.49-.13-3-.4-6.08-.4-9v-5.42a194.6,194.6,0,0,1,.93-19.59c.13-.92.13-1.85.26-2.78.67-5.82,1.59-11.51,2.78-17.2a21.2,21.2,0,0,1,.67-2.78,155.74,155.74,0,0,1,4.36-15.35c.27-.93.67-1.86.93-2.78a127.72,127.72,0,0,1,5.82-13.9H697a128.57,128.57,0,0,0-6,13.9c-.39.92-.66,1.85-1.06,2.78a148.59,148.59,0,0,0-4.36,15.48c-.27.93-.4,1.85-.66,2.78-1.2,5.69-2.12,11.38-2.78,17.2-.14.93-.14,1.86-.27,2.78a192,192,0,0,0-.92,19.46v5.42c.13,2.92.26,6,.39,8.87.4,5.3.93,10.59,1.46,15.75.13.93.26,1.85.4,2.78.79,5.69,1.72,11.38,2.77,16.94.14.93.4,1.85.53,2.91,1.33,6.75,2.92,13.5,4.5,20.25a21.59,21.59,0,0,1,.67,2.78c.92,4,2,7.81,3,11.65-.79.26-1.72.53-2.65.79",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path934",
    d: "M722,420.69c.14-1.21.27-2.41.4-3.61.14-.94.14-1.88.27-2.81q.81-9.22,1.21-18.46c0-.94.13-1.87.13-2.81.27-6.29.53-12.57.53-18.72v-7.23c0-7.09-.13-14.18-.4-21.13,0-.94-.13-1.87-.13-2.81-.27-7.09-.67-14.18-1.34-21.27-.13-.93-.13-1.87-.27-2.81-.4-5.48-1.07-11-1.6-16.31a19.22,19.22,0,0,1-.27-2.81c-.67-5.35-1.34-10.84-2.14-16.19-.13-.93-.27-1.87-.4-2.81-.67-4.41-1.47-8.82-2.14-13.1h2.81c.8,4.28,1.47,8.56,2.14,13,.13.94.27,1.87.4,2.81.8,5.35,1.47,10.83,2.14,16.18.13.94.27,1.88.4,2.81.67,5.49,1.21,10.84,1.61,16.32.13.94.13,1.87.26,2.81.54,7.09.94,14.18,1.34,21.27,0,.93.14,1.87.14,2.81.26,7.08.4,14.31.4,21.4v7.09c-.14,6.28-.27,12.7-.54,19,0,.94-.13,1.87-.13,2.81-.27,6.15-.67,12.17-1.21,18.32-.13.94-.13,1.87-.26,2.81s-.14,1.74-.27,2.68a8.79,8.79,0,0,0-3.08.8",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path938",
    d: "M752,404.82c.41-3.24.81-6.48,1.08-9.59.14-1,.14-1.89.27-2.84.68-7,.95-14.05.95-21.08v-2.83a240.56,240.56,0,0,0-1.49-26.22c-.13-.94-.13-1.89-.27-2.84-.81-6.89-1.89-13.91-3.24-20.67-.14-.94-.41-1.89-.54-2.84-1.08-5.27-2.43-10.53-3.78-15.8-.27-.95-.54-1.9-.82-2.71-1.48-5.4-3.24-10.67-5.13-15.94-.27-.95-.68-1.76-.95-2.7-1.35-3.79-2.83-7.43-4.45-11.22h3.1c1.49,3.52,2.84,7.16,4.19,10.81a21.23,21.23,0,0,1,1,2.7c1.89,5.27,3.65,10.54,5.13,15.95.27.94.54,1.89.81,2.7,1.49,5.13,2.71,10.4,3.79,15.67.13.95.4,1.9.54,2.71q2,10.34,3.24,20.67a21,21,0,0,1,.27,2.84c1,8.78,1.35,17.56,1.49,26.34v2.84c0,7.16-.41,14.19-1,21.22-.13.94-.13,1.89-.27,2.83-.27,2.3-.41,4.6-.68,6.89a33.29,33.29,0,0,1-3.24,3.11",
    style: {
      fill: "#627d77"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path942",
    d: "M776.5,305.33c-1.36-3.26-2.72-6.39-4.35-9.52-.41-.82-.81-1.77-1.22-2.59a166.62,166.62,0,0,0-8.57-15.09c-.54-.82-1.09-1.77-1.63-2.59-1.5-2.31-3.13-4.62-4.76-6.8,1.36.14,2.72.27,3.81.41h0c-.55-.14-1.23-.14-1.91-.27l2,.41c1.36,1.9,2.59,3.81,3.81,5.71.54.82,1.09,1.77,1.63,2.58,2.72,4.36,5.17,8.71,7.48,13.2a107.34,107.34,0,0,1,3.67,14.55",
    style: {
      fill: "#627d77"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path946",
    d: "M763,269.68c-.27-.14-.54-.14-.81-.27a2,2,0,0,0,.81.27m-1-.14h0",
    style: {
      fill: "#ec5142"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path950",
    d: "M763,269.68l-3-.54V269c.81.14,1.49.27,2.17.41h0a2,2,0,0,0,.81.27h0",
    style: {
      fill: "#5b827a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path954",
    d: "M760,269.27l-2-.4a10.56,10.56,0,0,1,2,.4h0",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path958",
    d: "M701.13,456.37c-35.91,0-71-2.9-78.44-7.32h0c2.9,1.66,9.8,3.18,19.33,4.42h0l3.87.42h0c7,.69,15.33,1.38,24.16,1.79h0c1,0,2.08.14,3.18.14h0c8.42.41,17.4.55,26.38.55h3c5,0,10.08-.14,15.05-.27h0a20.19,20.19,0,0,0,2.9-.14h0c6.76-.28,13.26-.55,19.47-1h0c1.11-.14,2.07-.14,3-.28h0c11.6-1,22-2.34,29.55-4.28h0c1.24-.27,2.49-.69,3.59-1h0a23.85,23.85,0,0,0,5.94-2.49c5.11-2.9,10.08-8,14.5-14.64h0c.69-1.1,1.52-2.21,2.21-3.31h0a151.27,151.27,0,0,0,11.46-23.75h0a29.36,29.36,0,0,0,1.11-3.18h0c1.52-4,2.76-8,4-12h0c.28-1,.55-1.93.83-2.9h0a156.27,156.27,0,0,0,5.39-29.41h0c0-1,.13-2.07.13-3h0v-2.07c0,26.52-17.4,81.89-39.63,94.32-11.74,6.63-46.68,9.39-81.06,9.39m-78.44-7.46h0m-.14,0h0m0-.13h0m-.14,0h0",
    style: {
      fill: "#f8ede4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path962",
    d: "M702.61,456.36c-1.24-4.14-2.48-8.42-3.73-12.56,6.91-.14,13.81-.42,20.58-.83-.55,4.42-1.24,8.84-1.93,13.12-4.84.14-9.95.27-14.92.27m-2.9,0c-9,0-18-.27-26.37-.55-1.8-4.14-3.46-8.15-5.25-12.29,7,.28,14.22.42,21.26.42H696c1.25,4,2.49,8.28,3.73,12.42m20.72-.27c.69-4.42,1.38-8.84,1.93-13.26,7.32-.41,14.78-1.1,22.1-1.93-1.39,4.83-2.91,9.53-4.42,14.22-6.22.42-12.85.69-19.61,1m-50.27-.55c-8.84-.42-17-1-24.17-1.8a128,128,0,0,1-8.7-12.57q13.88,1.45,27.76,2.08c1.52,4.14,3.31,8.28,5.11,12.29m72.91-.69c1.66-4.7,3-9.53,4.42-14.23,10.5-1.24,20.86-2.76,31.21-4.56a146.94,146.94,0,0,1-6.21,14.64c-7.46,1.8-17.82,3.18-29.42,4.15m-100.94-1.52c-9.53-1.25-16.58-2.63-19.34-4.42h-.41a58.84,58.84,0,0,1-12.71-11.19c8,1.24,16,2.35,24,3.18,2.63,4.28,5.39,8.42,8.43,12.43m134.09-3.73c2.07-4.7,4-9.39,5.8-14.23,5-1,9.8-1.93,14.64-2.9-4.42,6.63-9.39,11.74-14.5,14.64a43.34,43.34,0,0,1-5.94,2.49M689.35,441c-7.45,0-15.05-.14-22.51-.56-.69-1.79-1.51-3.59-2.21-5.38a196.82,196.82,0,0,0,27.49-5c1,3.59,2.07,7.18,3,10.77-1.93.14-3.86.14-5.8.14m8.7-.14c-1.1-3.87-2.21-7.6-3.17-11.46a223.25,223.25,0,0,0,27.2-8.84c-.55,6.49-1.38,13-2.21,19.47-7.18.55-14.5.83-21.82.83m-34.24-.55c-9.53-.42-18.92-1.25-28.31-2.21l-1.25-2.08c2.9.14,5.8.14,8.84.14a172.83,172.83,0,0,0,18.78-1c.56,1.79,1.25,3.45,1.94,5.11m59-.42c.83-6.77,1.66-13.53,2.35-20.44,2.49-1,4.83-2.07,7.32-3,5.94-.41,12-1,17.95-1.51-1.38,7.73-3,15.46-5.11,23.06-7.45.83-14.91,1.38-22.51,1.93m-90.86-2.21c-8.43-1-16.85-2.07-25.14-3.45a17.11,17.11,0,0,0-1.52-1.8,198.81,198.81,0,0,0,25.55,3.59,12,12,0,0,1,1.11,1.66m116.41-.14a220.75,220.75,0,0,0,5-23.06c11.05-1.24,22.1-2.76,33-4.56a167,167,0,0,1-6.49,22.93c-10.36,1.93-21,3.45-31.49,4.69m34.8-5.24a164.6,164.6,0,0,0,6.22-22.93c7-1.24,14.08-2.62,21-4.14A146.31,146.31,0,0,1,798.87,429q-7.87,1.86-15.75,3.32M739.76,413a64.2,64.2,0,0,0,12.29-8.28c-.28,2.34-.69,4.83-1.1,7.18-3.73.55-7.46.83-11.19,1.1m14.09-1.38c.55-3.31,1-6.49,1.38-9.8a61.08,61.08,0,0,0,6.35-7.05c9.25-.41,18.37-1.1,27.62-1.93q-.83,7.05-2.07,14.09c-11.19,1.93-22.24,3.59-33.28,4.69m36-5.11c.83-4.56,1.52-9.25,2.07-13.81,7.87-.69,15.61-1.52,23.48-2.48-1.25,4-2.49,8-4,12-7,1.52-14.36,2.9-21.54,4.28m-26.24-14.64a82.24,82.24,0,0,0,11.05-23.61q7.66-1.25,15.33-2.9c.14,2.62.14,5.25.14,7.73,0,5.66-.28,11.33-.83,16.85-8.57.83-17.13,1.52-25.69,1.93m28.59-2.07q.82-8.28.83-16.57c0-2.76-.14-5.52-.14-8.42,9.66-2.07,19.33-4.42,28.86-7.05a155.56,155.56,0,0,1-5.39,29.42c-8.14,1-16.15,1.79-24.16,2.62m-16.85-24.58a117.81,117.81,0,0,0,3.73-27.76c2.34-.55,4.55-1,6.9-1.52a169.17,169.17,0,0,1,3.73,26.52h0c-4.69,1.1-9.53,1.93-14.36,2.76m17.26-3.31a169.17,169.17,0,0,0-3.73-26.52c9.25-2.07,18.37-4.56,27.48-7.18a73.68,73.68,0,0,1,5.11,19.06,33.86,33.86,0,0,1,.28,5.52v2.07c-9.67,2.63-19.33,5-29.14,7.05m-13.39-27.35a145.05,145.05,0,0,0-1.39-20.85c.56-.14,1.11-.28,1.8-.41a194.47,194.47,0,0,1,5.94,19.88c-2.21.55-4.28,1-6.35,1.38m9-1.93a164.24,164.24,0,0,0-5.94-19.89q11.4-2.48,22.79-5.8a133.75,133.75,0,0,1,10.08,18.51c-8.84,2.76-17.81,5.11-26.93,7.18M777.46,311c-.28-1.93-.55-3.73-1-5.66.69,1.79,1.52,3.59,2.07,5.38-.27.14-.69.14-1.1.28m4-.83c-1.94-5.11-4-10.08-6.36-14.91,5.94-1.25,11.88-2.63,17.68-4.29a156.3,156.3,0,0,1,10.77,13.68c-7.32,1.93-14.64,3.86-22.09,5.52m-7.6-17.54a11.24,11.24,0,0,0-1-1.79,100.67,100.67,0,0,0-5.38-13.68c2.62-.55,5.25-1,7.87-1.51a92,92,0,0,1,15.33,13c-5.66,1.38-11.33,2.76-16.85,4m-7.73-18.09a33.39,33.39,0,0,0-3.18-4.83,43.28,43.28,0,0,1,8.84,3.73c-1.94.41-3.73.82-5.66,1.1",
    style: {
      fill: "#5b827a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path966",
    d: "M689.32,443.87q-10.7,0-21.4-.41c-.4-.94-.8-1.88-1.21-2.82,7.54.27,14.94.54,22.48.54H695l.81,2.82c-2-.13-4.17-.13-6.46-.13m9.56-.14-.81-2.82q10.9-.21,21.8-.81c-.13.94-.27,1.88-.4,2.83q-10.31.6-20.59.8m-33.92-.4c-9.28-.4-18.43-1.08-27.72-2-.67-.94-1.21-2-1.88-3,9.42.94,18.84,1.75,28.39,2.29a24.12,24.12,0,0,1,1.21,2.69m57.47-.54c.13-.94.27-1.88.4-2.82,7.54-.54,15.07-1.22,22.48-2-.27.94-.54,2-.81,3-7.4.8-14.67,1.34-22.07,1.88",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path970",
    d: "M633.72,440.81c-8-.95-16.06-1.9-24.1-3.26l-2.86-3.27c8.31,1.36,16.75,2.59,25.19,3.54.55.95,1.23,2,1.77,3m113.84-.27c.27-1,.54-1.9.82-3,10.62-1.23,21.1-2.86,31.59-4.77-.41,1.09-.68,2-1.09,3.13-10.49,1.91-20.84,3.41-31.32,4.63",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path974",
    d: "M782,435.39c.41-1,.69-2.06,1.1-3,5.34-1,10.55-2.05,15.76-3.29-.69,1.1-1.37,2.33-2.2,3.43-4.79,1-9.73,1.92-14.66,2.88",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path978",
    d: "M732.46,416.5c1.23-.55,2.59-1.09,3.82-1.64s2.32-1.09,3.41-1.63c3.69-.28,7.51-.69,11.19-1.1-.13,1-.27,1.91-.4,2.87-6.15.55-12,.95-18,1.5m20.88-1.91c.14-1,.27-1.91.41-2.87,11.06-1.22,22.11-2.73,33.17-4.64-.14,1-.41,1.91-.55,3-11,1.77-22,3.27-33,4.5",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path982",
    d: "M789.29,409.48c.14-1,.42-1.93.55-3,7.3-1.24,14.45-2.75,21.61-4.27a31.41,31.41,0,0,0-1.1,3.17q-10.53,2.26-21.06,4.13",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path986",
    d: "M761.42,394.74c.69-1,1.51-1.91,2.19-2.87,8.6-.41,17.21-1.09,25.68-1.78-.14,1-.14,1.92-.27,2.87-9.16.69-18.31,1.37-27.6,1.78",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path990",
    d: "M792,392.64c.13-1,.13-1.93.27-2.89,8-.69,16-1.66,24-2.62-.28,1-.55,1.93-.83,2.89-7.86,1-15.71,1.93-23.43,2.62",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path994",
    d: "M774.61,368.3c.28-1,.55-2.05.82-3,4.79-.82,9.57-1.77,14.35-2.73,0,1,.14,1.91.14,2.87-5.06.95-10.11,1.91-15.31,2.87",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path998",
    d: "M792.75,364.8c0-.83-.13-1.66-.13-2.49v-.41c9.8-2.07,19.47-4.56,29.13-7.18,0,1-.13,1.93-.13,3-9.53,2.62-19.06,5-28.87,7",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1002",
    d: "M779.17,337.53v-2.9c2.06-.41,4.13-.82,6.2-1.37.27,1,.41,1.79.69,2.75-2.21.55-4.55,1-6.89,1.52m9.78-2.21c-.13-1-.41-1.79-.55-2.75,9.1-2.07,18.06-4.41,27-7,.41.82.69,1.79,1.1,2.62-9.23,2.75-18.47,5.1-27.57,7.16",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1006",
    d: "M778,313.7c-.14-1-.28-1.92-.41-2.74.41-.14.82-.14,1.23-.28.28.82.69,1.79,1,2.61-.68.14-1.23.27-1.78.41m4.39-1c-.27-.82-.68-1.78-1-2.61,7.42-1.65,14.83-3.43,22.11-5.49l1.65,2.47c-7.55,2.06-15.11,4-22.8,5.63",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1010",
    d: "M775.09,295.16c-.41-.82-.82-1.78-1.23-2.6,5.61-1.23,11.22-2.46,16.82-4,.69.82,1.51,1.51,2.19,2.33-5.88,1.5-11.9,3-17.78,4.24",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1014",
    d: "M767.56,277.13c-.4-.95-.95-1.77-1.36-2.59,1.91-.4,3.81-.68,5.72-1.08,1.22.68,2.31,1.36,3.53,2.17-2.72.55-5.3.95-7.89,1.5",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1018",
    d: "M646,453.86l-3.9-.39a144.51,144.51,0,0,1-8.46-12.62c-.65-1-1.16-2.08-1.82-3-.39-.65-.65-1.17-1-1.82a29.47,29.47,0,0,0,3.39.13c.39.65.78,1.3,1.17,2.08.65,1,1.17,2.08,1.82,3,2.73,4.29,5.72,8.59,8.84,12.62",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1022",
    d: "M673.22,455.72c-1.05,0-2.1-.13-3.15-.13-1.71-4.07-3.55-8.14-5.12-12.34-.4-.92-.79-2-1.18-2.89-.66-1.7-1.32-3.28-2-5,.92-.14,2-.14,2.89-.27.65,1.84,1.44,3.68,2.23,5.38.39.92.78,2,1.18,2.89,1.7,4.2,3.41,8.27,5.12,12.34",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1026",
    d: "M701.11,456.31h-1.46c-1.19-4.11-2.52-8.36-3.71-12.47l-.8-2.78c-1.06-3.58-2-7.16-3-10.88.93-.26,1.86-.39,2.79-.66,1.06,3.85,2.12,7.69,3.18,11.4.27.93.53,1.86.8,2.79,1.19,4.24,2.52,8.35,3.71,12.6h-1.46",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1030",
    d: "M717.61,456.11c.67-4.41,1.34-8.82,2-13.1.14-.93.27-1.87.4-2.8.81-6.42,1.61-13,2.28-19.38.93-.4,2-.8,2.94-1.2-.67,6.81-1.47,13.63-2.28,20.44-.13.94-.26,1.87-.4,2.81-.66,4.41-1.2,8.82-2,13.23h-2.94",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1034",
    d: "M740,455.12q2.43-7.1,4.45-14.18c.27-.94.54-1.89.81-3,2-7.56,3.78-15.26,5.13-23.09A21.84,21.84,0,0,1,751,412c.41-2.43.68-4.72,1.09-7.15,1.08-.95,2.16-1.89,3.24-3-.41,3.24-.81,6.48-1.35,9.72-.14.94-.27,1.89-.41,2.84-1.35,7.69-3,15.39-5,23.08-.27.95-.54,1.9-.81,3-1.35,4.86-2.83,9.58-4.45,14.31a23.32,23.32,0,0,0-3.24.27",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1038",
    d: "M772.67,450.58A138.58,138.58,0,0,0,778.82,436c.41-1,.69-2.05,1.1-3a191.85,191.85,0,0,0,6.43-23c.13-1,.41-1.91.54-3,1-4.65,1.64-9.43,2.19-14.08.14-1,.14-1.92.27-2.88q.82-8.4.82-16.82c0-2.6,0-5.2-.13-7.79,0-1-.14-1.92-.14-2.88h0A175.29,175.29,0,0,0,786.21,336a19.63,19.63,0,0,0-.69-2.74,205.89,205.89,0,0,0-5.88-20c-.27-1-.68-1.78-.95-2.74-.69-1.78-1.37-3.56-2.19-5.33a125.12,125.12,0,0,0-3.56-14.5,11.08,11.08,0,0,0,1,1.78c.41.82.82,1.77,1.23,2.6,2.32,4.92,4.51,9.84,6.43,14.9.27,1,.68,1.78,1,2.74a206.34,206.34,0,0,1,5.89,19.83c.27,1,.41,1.78.68,2.74a174,174,0,0,1,3.69,26.53v.41c0,.82.14,1.64.14,2.46.14,2.74.14,5.61.14,8.34,0,5.61-.28,11.08-.82,16.55-.14,1-.14,1.92-.28,2.88-.54,4.65-1.23,9.3-2.05,13.81-.14,1-.41,1.91-.55,3a208.35,208.35,0,0,1-6.15,22.84c-.41,1.09-.68,2.05-1.1,3-1.77,4.78-3.69,9.57-5.74,14.22a38,38,0,0,1-3.69,1.23",
    style: {
      fill: "#5f746a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1042",
    d: "M620.44,413.57a4.85,4.85,0,0,1-2.35-.92l2.61.39c0,.14.13.4.13.53-.13-.13-.26,0-.39,0m-.79-3.66c-2.09-.27-4.18-.53-6.27-.92a47.18,47.18,0,0,1-14.65-24.06c5.1.92,10.2,1.7,15.43,2.48a132.17,132.17,0,0,0,5.49,22.5m-6-25.37c-5.23-.79-10.46-1.7-15.69-2.62a74.91,74.91,0,0,1-1.57-17.26c5.23,1.18,10.46,2.09,15.69,3.14.26,5.62.78,11.25,1.57,16.74m-1.57-19.62c-5.23-.91-10.33-2-15.56-3A101.7,101.7,0,0,1,600,340.34c4.58.78,9,1.57,13.6,2.22a122.82,122.82,0,0,0-1.31,13.73c-.13,2.36-.13,4.84-.13,7.19a4.55,4.55,0,0,0-.13,1.44m2.88-4.18c0-1.44.13-3,.13-4.45.26-4.44.65-9,1.31-13.47,3.66.53,7.32,1.05,11.11,1.44-1.31,1.18-2.48,2.22-3.79,3.27A28,28,0,0,0,615,360.74m15.3-19c-4.45-.53-8.9-1-13.34-1.7a152.84,152.84,0,0,1,5.75-23c8.37,1.44,16.87,2.49,25.37,3.4a3.91,3.91,0,0,0-.26,1.31,203.09,203.09,0,0,1-17.52,20M614,339.68c-4.44-.65-8.89-1.43-13.34-2.22a120,120,0,0,1,9-22.75c3.27.65,6.67,1.31,9.93,1.83A171.62,171.62,0,0,0,614,339.68m34.65-22c-8.36-.92-16.73-2-25.1-3.4a157,157,0,0,1,7.84-18.05c7.59,1.44,15.3,2.75,22.89,3.66a173.75,173.75,0,0,0-5.63,17.79m3.54-2.49a149.08,149.08,0,0,1,5-14.78c.92.14,1.83.27,2.88.4a89.19,89.19,0,0,1-7.84,14.38m-31.52-1.44c-3.14-.52-6.41-1.17-9.55-1.83a94.76,94.76,0,0,1,12-17.39c1.7.39,3.53.78,5.23,1.18a181.14,181.14,0,0,0-7.72,18M661,298a19.68,19.68,0,0,0-2.75-.26c1.18-2.88,2.49-5.89,3.92-8.63.4,2.48-.13,5.49-1.17,8.89m-5.63-.65c-7.58-.92-15-2.1-22.62-3.66,2.22-4.06,4.58-7.85,7.06-11.64a7.65,7.65,0,0,1,1.57-.53c5.89.66,11.77,1.31,17.65,1.7a14.2,14.2,0,0,1,1.84,2.1c-2,3.92-3.8,7.84-5.5,12m-25.5-4.19c-1.43-.26-3-.65-4.44-.91a50.07,50.07,0,0,1,9.41-7.72c-1.7,2.88-3.4,5.76-5,8.63",
    style: {
      fill: "#6d9694"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1046",
    d: "M620.61,413l-2.58-.39a20.06,20.06,0,0,1-2.57-1.8c-.78-.52-1.42-1.16-2.07-1.68,2.07.26,4.26.64,6.32.9.26,1,.64,1.94.9,3",
    style: {
      fill: "#718984"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1050",
    d: "M614.08,387.48c-5.14-.77-10.28-1.67-15.42-2.44-.26-1-.52-1.93-.77-3,5.27.9,10.41,1.8,15.68,2.57a19.54,19.54,0,0,1,.51,2.83",
    style: {
      fill: "#718984"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1054",
    d: "M612.22,367.83q-7.9-1.35-15.8-3.08a20.62,20.62,0,0,1,.13-2.83c5.13,1.16,10.4,2.19,15.54,3.09a21.44,21.44,0,0,0,.13,2.82",
    style: {
      fill: "#718984"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1058",
    d: "M627.43,344.27c-3.75-.39-7.37-.9-11.12-1.42.13-.91.26-1.81.39-2.84,4.4.64,8.92,1.16,13.32,1.68a24.27,24.27,0,0,1-2.59,2.58m-13.83-1.81c-4.53-.64-9.05-1.42-13.57-2.2.25-.9.51-1.81.77-2.71,4.4.77,8.79,1.55,13.32,2.2a14.34,14.34,0,0,0-.52,2.71",
    style: {
      fill: "#718984"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1062",
    d: "M648,320.37c-8.46-.91-16.92-2.08-25.37-3.39.26-.91.65-1.82.91-2.73,8.33,1.43,16.78,2.47,25.11,3.39-.26.91-.39,1.82-.65,2.73m-28.24-3.91c-3.38-.52-6.63-1.17-10-1.82.52-.91.91-1.69,1.43-2.6,3.13.65,6.38,1.17,9.5,1.82-.26.91-.65,1.69-.91,2.6",
    style: {
      fill: "#718984"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1066",
    d: "M660,300.67l-2.88-.39c.4-.92.66-1.83,1-2.75a19.56,19.56,0,0,0,2.74.27,10.58,10.58,0,0,1-.91,2.87m-5.62-.65c-7.71-1-15.29-2.23-22.87-3.66a24.3,24.3,0,0,1,1.44-2.62c7.45,1.44,15,2.62,22.61,3.66a9.24,9.24,0,0,0-1.18,2.62m-25.88-4.32-5.36-1.17c.79-.79,1.44-1.7,2.22-2.36,1.44.27,3,.66,4.45.92a16.32,16.32,0,0,1-1.31,2.61",
    style: {
      fill: "#718984"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1070",
    d: "M659.12,283.13c-5.88-.39-11.76-1-17.64-1.7a20.39,20.39,0,0,1,4.58-.91,24.19,24.19,0,0,1,3-.13c4.57,0,8,1,10.06,2.74",
    style: {
      fill: "#718984"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1074",
    d: "M620.79,413.43c0-.13-.13-.39-.13-.52-.39-1-.65-1.94-1-3A153.28,153.28,0,0,1,614,387.49c-.13-1-.26-1.95-.39-3a145,145,0,0,1-1.43-16.73,20.84,20.84,0,0,0-.13-2.85v-1.69c0-2.34,0-4.8.13-7.14.26-4.54.65-9.08,1.3-13.62l.39-2.72a157.61,157.61,0,0,1,5.71-23.09c.26-.91.65-1.82.91-2.73a148.46,148.46,0,0,1,7.78-18c.39-.9.91-1.68,1.3-2.59,1.55-3,3.24-5.84,4.93-8.56a28.75,28.75,0,0,1,4.93-2.47q-3.71,5.64-7,11.68c-.52.91-.91,1.68-1.43,2.59a175,175,0,0,0-7.91,18c-.26.91-.65,1.82-.91,2.73a139.43,139.43,0,0,0-5.83,23.09l-.39,2.72c-.65,4.41-1,8.95-1.3,13.36-.13,1.56-.13,3-.13,4.54-6.49,21.54,10.38,50.85,6.23,52.41",
    style: {
      fill: "#718984"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1078",
    d: "M647.73,321.67c.13-.4.13-.79.26-1.31.26-.92.4-1.83.66-2.75A163.93,163.93,0,0,1,654.27,300c.39-.91.65-1.83,1.05-2.74,1.69-4.06,3.53-8.11,5.49-12.16a10.8,10.8,0,0,1,1.3,3.79c-1.43,2.87-2.61,5.75-3.92,8.63-.39.91-.65,1.83-1,2.74-1.83,4.84-3.53,9.81-5,14.78a60.43,60.43,0,0,1-4.45,6.67",
    style: {
      fill: "#718984"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1082",
    d: "M592.49,268.58c10.59-1.22,71-32.59,94.24-.95,23.77-32.32,76.86-9.37,84.88-17.79.13,2.18.13,4.35.13,6.52,0,.95-16.43,2.58-21.86,2.18-.41,0,21.86,1.63,21.86,2.17,0,6.24-.13,11.27-.13,11.27s-69.4-14.26-84.2,0c-25.53-12.22-77.68,8.42-83.25,12.63-.95.68-5.29-5.84-8.55-10.87-.14-.27,9.23-4.61,9-4.48-6.11,2.31-9.91,3-10.18,2.58-1.09-1.76-1.9-3.26-1.9-3.26",
    style: {
      fill: "#ebeef3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1086",
    d: "M601.9,287.29c3.39-3.4,48.65-24.6,85.89-11.55,35.34-20.8,86.57-.27,86.57-.27",
    style: {
      fill: "none",
      stroke: "#3b3f3e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "9.108350861118595px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1090",
    d: "M695.73,264.43a44.18,44.18,0,0,1,12.54-7,42.85,42.85,0,0,1,14.16-2.29,101.15,101.15,0,0,1,14.29,1.21c4.72.68,9.44,1.49,14.16,1.89-4.72-.13-9.57-.67-14.29-1.21a127.41,127.41,0,0,0-14.3-1.08,45.18,45.18,0,0,0-14,2.16,57.28,57.28,0,0,0-12.54,6.34",
    style: {
      fill: "#5e8c89"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1094",
    d: "M635.38,266a35.51,35.51,0,0,1,8.79-3.15,71.36,71.36,0,0,1,9.32-1.31,57.29,57.29,0,0,1,9.44.26,37.49,37.49,0,0,1,9.19,2.23,55.55,55.55,0,0,0-9.19-1.57,70.57,70.57,0,0,0-9.31-.13,69.27,69.27,0,0,0-9.19,1.05c-3,.78-6,1.57-9,2.62",
    style: {
      fill: "#5e8c89"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1098",
    d: "M606.21,268.24c2.59-1.16,5.19-2.33,7.78-3.37s5.19-2.07,7.91-3a82,82,0,0,1,8.17-2.46,23,23,0,0,1,8.43-.78,26.12,26.12,0,0,0-8.3,1.42c-2.72.78-5.32,1.69-8,2.6s-5.32,1.94-7.91,2.85-5.45,1.82-8,2.72",
    style: {
      fill: "#5e8c89"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCouch2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/couch2.011a3ae5d70230a3c5faabedb25a6633.svg";